<!--<div>-->
<!--    <h1>-->
<!--        Thank you-->
<!--    </h1>-->
<!--</div>-->

<!--<div class="icbc-alert-box icbc-alert-box-success">-->
<!--    <mat-icon class="icbc-alert-icon">check_circle_outline</mat-icon>-->
<!--    <span>-->
<!--        Your email is on its way! Documents have been sent to {{email}}. If you don't see the email in the next 10 minutes, please check your spam or junk folder first then try your request again.-->
<!--    </span>-->
<!--</div>-->
<div class="flex-column text-center mt-50">
    <div class="text-center mt-20" id="goodbye-icon-wrapper">
        <mat-icon id="goodbye-icon" class="icbc-alert-icon">check_circle_outline</mat-icon>
    </div>
    <div class="text-center">
        <h1> Thank you </h1>
    </div>
    <div id="thank-you-text-wrapper" class="text-center mt-20">
        <span id="thank-you-text">
            Your email is on its way! Documents have been sent to {{email$ | async}}. If you don't see the email in
          the
          next 10
            minutes, please check your spam or junk folder first then try your request again.
        </span>
    </div>
    <div class="mt-50 thank-you-button-wrapper">
        <button mat-stroked-button class="icbc-button" (click)="returnToHomePage()">
<!--            <a href="https://www.icbc.com/driver-licensing/getting-licensed/Pages/Your-driving-record.aspx">-->
                Return to Home
<!--            </a>-->
        </button>
    </div>
</div>
